import "../../resources/less/Troubadour/LoggedOut/AboutSubpage.less";

class AboutSubpage {
  private footerContainer: HTMLElement;
  private subPageNav: HTMLElement;

  constructor() {
    this.footerContainer = $("#footer")[0];
    this.subPageNav = $("#subpage-nav")[0];
    this.setSubPageNavContext();
    $(window).on("resize scroll", () => {
      this.setSubPageNavContext();
    });
  }

  private setSubPageNavContext(): void {
    const isFooterVisible = this.isInViewport(this.footerContainer);
    if (isFooterVisible) {
      $(this.subPageNav).attr("data-nav-context", "inline");
    } else {
      $(this.subPageNav).attr("data-nav-context", "fixed");
    }
  }

  private isInViewport(element: HTMLElement): boolean {
    const rect = element.getBoundingClientRect();
    const vWidth = window.innerWidth || document.documentElement.clientWidth;
    const vHeight = window.innerHeight || document.documentElement.clientHeight;

    // Return false if not in the viewport
    if (
      rect.right < 0 ||
      rect.bottom < 0 ||
      rect.left > vWidth ||
      rect.top > vHeight
    ) {
      return false;
    }

    // Return true if any of the four corners are visible
    return (
      element.contains(document.elementFromPoint(rect.left, rect.top)) ||
      element.contains(document.elementFromPoint(rect.right, rect.top)) ||
      element.contains(document.elementFromPoint(rect.right, rect.bottom)) ||
      element.contains(document.elementFromPoint(rect.left, rect.bottom))
    );
  }
}

$(window).on("load", () => {
  new AboutSubpage();
});
